import { render, staticRenderFns } from "./VasionVerticalSplitOutlinedIcon.svg?vue&type=template&id=c3abf742"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports